export const VC4A_VARS = {
    VC4A_SITE_ASSETS_PATH: process.env.VUE_APP_VC4A_SITE + '/wp-content/themes/vc4africa/resources/' || null,
};
